import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '../../../components/ui/tabs'
import { CustomerCardDetails } from './components/CustomerCardDetails'
import { CustomerPerfil } from './components/CustomerPerfil'
import { useCustomerDetailsPageController } from './useCustomerDetailsPageController'
import { Spinner } from '../../../components/ui/spinner'
import { CustomerTransactionsPage } from '../CustomerTransactionsPage'
import { FormProvider } from 'react-hook-form'
import { CustomerPersonalInfo } from './components/CustomerPersonalInfo'
import ButtonBack from '../../../components/ButtonBack'
import { TransactionProvider } from '../../../../app/contexts/TransactionContext'
import { BanksProvider } from '../../../../app/contexts/banksContext'

export const CustomerDetailsPage = () => {
  const { data, isFetching, isLoading, methods } =
    useCustomerDetailsPageController()

  return (
    <div className="flex flex-col items-start ">
      <ButtonBack label={data?.name} />

      {(isFetching || isLoading) && (
        <div className="flex h-screen w-full items-center justify-center">
          <Spinner />
        </div>
      )}

      {data && (
        <Tabs defaultValue="perfil" className="w-full">
          <TabsList className="my-10 flex justify-start gap-2 bg-transparent xs:my-4 xs:gap-6">
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="perfil"
            >
              Perfil
            </TabsTrigger>
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="transactions"
            >
              Transações
            </TabsTrigger>
          </TabsList>

          <TransactionProvider>
            <BanksProvider>
              <div className="flex flex-col items-start gap-6 md:flex-row lg:gap-12">
                <div className="mt-2 w-full max-w-[450px]">
                  <CustomerCardDetails name={data.name} />
                  <CustomerPersonalInfo data={data} />
                  {/* <CustomerBankInfo
                    bankAccount={data.bankAccount}
                    getBank={getBank}
                  /> */}
                </div>
                <div className="w-full">
                  <TabsContent value="perfil" className="w-full">
                    <FormProvider {...methods}>
                      <CustomerPerfil />
                    </FormProvider>
                  </TabsContent>

                  <TabsContent value="transactions" className="w-full">
                    <CustomerTransactionsPage />
                  </TabsContent>
                </div>
              </div>
            </BanksProvider>
          </TransactionProvider>
        </Tabs>
      )}
    </div>
  )
}
